/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClickGalleryUpdate
 */
export interface ClickGalleryUpdate {
    /**
     * 
     * @type {string}
     * @memberof ClickGalleryUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClickGalleryUpdate
     */
    description?: string | null;
}

export function ClickGalleryUpdateFromJSON(json: any): ClickGalleryUpdate {
    return ClickGalleryUpdateFromJSONTyped(json, false);
}

export function ClickGalleryUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClickGalleryUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function ClickGalleryUpdateToJSON(value?: ClickGalleryUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}


